import { AnyAction } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "redux/store/Store";
import { ArrowForward } from "@material-ui/icons";
import Resource from "components/Resources/Resource";
import { IApplication } from "redux/reducers/tenantReducer";
import { ICultureState } from "redux/reducers/cultureReducer";
import { getAllDepartaments } from "redux/actions/UsersAction";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import Input from '@material-ui/core/Input';

import {
  Container,
  Box,
  Typography,
  createStyles,
  makeStyles,
  Theme,
  Button,
  CircularProgress,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@material-ui/core";
import {
  getAllWorkspaces,
  getWorkspace,
  getSuggestedNamesWorkspaces,
  postWorkspaces,
  putWorkspacesDepartments
} from "redux/actions/workspaceAction";
import {
  IWorkspaceReducer,
  ISuggestedNamesWorkspaces,
  IWorkspaceState,
} from "redux/reducers/workspaceReducer";
import { IAuthUser } from "redux/reducers/authReducer";
import { IDepartments } from "redux/reducers/usersReducers";
import ToolTip from "components/ToolTip/ToolTip";

interface IDispatchProps {
  getAllWorkspace: (options: object) => Promise<IWorkspaceState>;
  getWorkspace: (options: object) => Promise<IWorkspaceState>;
  getSuggestedNamesWorkspace: (options: object) => Promise<IWorkspaceState>;
  postWorkspaces: (options: object) => Promise<any>;
  getDeparments: (options: object, culture: ICultureState) => Promise<any>;
  putWorkspaceDepartment: (option: object) => Promise<IWorkspaceState>;
}

interface IProps {
  setCurrentScreen: Dispatch<SetStateAction<number>>;
  istab?: boolean
}

interface IStateProps {
  authUser: IAuthUser;
  workspaces: IWorkspaceReducer;
  suggestedNames: ISuggestedNamesWorkspaces;
  application: IApplication;
  culture: ICultureState;
  departments: IDepartments[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    setWorkspaceTitle: {
      fontSize: "22px",
      textAlign: "left",
      color: "#313B53",
      fontWeight: 700,
      marginBottom: theme.spacing(7),
    },
    btnNames: {
      padding: "5px 8px",
      marginRight: "8px",
    },
  })
);

const options = {
  applicationId: 2,
  culture: {},
};

function StepWorkspaceDepartments(props: IDispatchProps & IStateProps & IProps) {
  const classes = useStyles();
  const theme = useTheme();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const {
    setCurrentScreen,
    getDeparments,
    getAllWorkspace,
    putWorkspaceDepartment,
    getWorkspace,
    culture,
    departments,
    workspaces,
    istab
  } = props;
  const [departmentsValue, setDepartmentsValue] = useState<string[]>(workspaces.departments ?? []);

  const { cultureTag } = culture?.culture ?? "";

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setDepartmentsValue(event.target.value as string[]);
  };

  const handleDelete = (item: any) => {
    setDepartmentsValue(departmentsValue.filter(department => department !== item))
  }

  useEffect(() => {
    getDeparments({ cultureTag }, culture);
  }, [])

  function putDepartmentsWorkspace() {
    setLoadingSubmit(true);

    let params = {
      culture: props?.culture,
      departments: departmentsValue,
      workspaceId: workspaces?.workspaceId,
    };

    options.culture = props?.culture;

    putWorkspaceDepartment(params).then(() => {
      if (!istab) {
        getAllWorkspace(options)
          .then(() => {
            setCurrentScreen((prevState) => prevState + 1);
          });
      } else {
        getWorkspace(params);
      }
      setLoadingSubmit(false);
    });

  }

  return (
    <Container>
      <Typography className={classes.setWorkspaceTitle}>
        <Resource tag="PageSetup::WorkspaceDepartaments" />
      </Typography>
      <FormControl fullWidth>
        <InputLabel shrink id="multiple-label">
          <Box display="flex" alignItems="center" gridGap="5px">
            <Resource tag="PageSetup::Departments" />
            <ToolTip children={<Resource tag="PageSetup::DepartmentsToltip" />} />
          </Box>
        </InputLabel>
        <Select
          labelId="multiple-label"
          id="multiple"
          multiple
          fullWidth
          value={departmentsValue}
          onChange={handleChange}
          input={<Input />}
        >
          {departments?.map((department) => (
            <MenuItem key={department.departmentId} value={department.departmentId}>
              {department.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box
        pt="5px"
        display="flex"
        gridGap="5px"
        flexWrap="wrap"
        justifyContent="center"
      >
        {departmentsValue?.map(item => {
          return (
            <Chip
              label={departments.filter(department => department.departmentId === item)[0]?.title}
              onDelete={() => handleDelete(item)}
              variant="outlined"
            />
          )
        })}
      </Box>

      <Box textAlign="right" mt={7}>
        <Button
          disabled={departmentsValue.length === 0}
          onClick={putDepartmentsWorkspace}
          color="primary"
          variant="contained"
          endIcon={
            !loadingSubmit ? (
              <ArrowForward className="icon icon-arrow" />
            ) : (
              <CircularProgress
                size={22}
                style={{ color: `${theme.palette.common.white}` }}
              />
            )
          }
        >
          {istab ?
            <Resource tag="PageSetup::Save" /> :
            <Resource tag="PageSetup::Continue" />
          }
        </Button>
      </Box>
    </Container>
  );
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>
): IDispatchProps => {
  return {
    getAllWorkspace: (options: object) => dispatch(getAllWorkspaces(options)),
    getWorkspace: (options: object) => dispatch(getWorkspace(options)),
    getSuggestedNamesWorkspace: (options: object) => dispatch(getSuggestedNamesWorkspaces(options)),
    postWorkspaces: (params: object) => dispatch(postWorkspaces(params)),
    getDeparments: (options: object, culture: ICultureState) => dispatch(getAllDepartaments(options, culture)),
    putWorkspaceDepartment: (options: object) => dispatch(putWorkspacesDepartments(options))
  };
};

const mapStateToProps = (store: IAppState): IStateProps => {
  return {
    authUser: store.authState.auth,
    departments: store.usersState.departaments,
    application: store.tenantState.application,
    culture: store.cultureState,
    workspaces: store.workSpacesState.workspaces,
    suggestedNames: store.workSpacesState.suggestedNamesWorkspaces,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepWorkspaceDepartments);